import React, { useState, useEffect } from 'react';
import { Grid, Paper, Typography, Box, CircularProgress, Divider } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import LoginIcon from '@mui/icons-material/Login';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import HistoryIcon from '@mui/icons-material/History';
import api from '../../api';

const GeneralSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const empId = localStorage.getItem('emp_id');

  useEffect(() => {
    api.get(`/dashboard/general/${empId}`)
      .then(res => { setData(res.data); setLoading(false); })
      .catch(err => { console.error(err); setLoading(false); });
  }, [empId]);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress size={24} /></Box>;
  if (!data) return <Typography color="error" variant="body2">Failed to load data.</Typography>;

  const CardHeader = ({ icon, title }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, color: 'text.secondary' }}>
      {icon}
      <Typography variant="body2" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{title}</Typography>
    </Box>
  );

  return (
    <Grid container spacing={3}>
      
      {/* Shift Timing */}
      <Grid item xs={12} md={3}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, height: '100%', borderColor: '#e0e0e0' }}>
          <CardHeader icon={<ScheduleIcon fontSize="small" />} title="Today's Shift" />
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>{data.today_shift_name}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>{data.today_shift_time}</Typography>
        </Paper>
      </Grid>

      {/* Sign-In Time */}
      <Grid item xs={12} md={3}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, height: '100%', borderColor: '#e0e0e0' }}>
          <CardHeader icon={<LoginIcon fontSize="small" />} title="Sign-In Time" />
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: data.is_late ? '#d32f2f' : '#1a1a1a' }}>
              {data.sign_in_time}
            </Typography>
            {data.is_late && <Typography variant="caption" sx={{ color: '#d32f2f', fontWeight: 'bold' }}>(Late)</Typography>}
          </Box>
        </Paper>
      </Grid>

      {/* Current Status */}
      <Grid item xs={12} md={3}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, height: '100%', borderColor: '#e0e0e0' }}>
          <CardHeader icon={<FingerprintIcon fontSize="small" />} title="Live Status" />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: data.current_status === 'IN' ? '#2e7d32' : '#d32f2f' }} />
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
              {data.current_status}
            </Typography>
          </Box>
        </Paper>
      </Grid>

      {/* Yesterday's Status */}
      <Grid item xs={12} md={3}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, height: '100%', borderColor: '#e0e0e0' }}>
          <CardHeader icon={<HistoryIcon fontSize="small" />} title="Yesterday" />
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>{data.yesterday_status}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>{data.yesterday_date}</Typography>
        </Paper>
      </Grid>

      {/* Leave Balances (Minimalist Row) */}
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, borderColor: '#e0e0e0' }}>
          <Typography variant="body2" sx={{ fontWeight: 600, textTransform: 'uppercase', color: 'text.secondary', mb: 2 }}>Leave Balances</Typography>
          <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            {Object.entries(data.leave_balances).map(([type, balance]) => (
              <Box key={type} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>{type}</Typography>
                <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>{balance}</Typography>
              </Box>
            ))}
          </Box>
        </Paper>
      </Grid>

    </Grid>
  );
};

export default GeneralSection;